import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { FlexGap, TextArea, tokens } from '@treams/treams-ui';

import GoalSelectorItem from '../../../../../../packages/@treams/treams-app/src/components/goals/GoalSelectorItem';

export default function FeedbackComposerGoalCard(props: {
	goal:
		| graphql.Goal
		| graphql.FeedbackRequestGoal
		| graphql.GoalRevision
		| graphql.EvaluationSubmissionGoal;
	text?: string;
	selected?: boolean;
	onChange?: (selected: boolean, text?: string) => void;
}) {
	const { t } = useTranslation();

	return (
		<FlexGap flexDirection="column" gap={tokens.gap.list}>
			<GoalSelectorItem goal={props.goal} selected={props.selected} onChange={props.onChange} />
			{props.selected && (
				<Box
					onClick={(event) => {
						event.stopPropagation();
					}}
				>
					<TextArea
						value={props.text ?? t('feedback.composer.goals.progressQuestion')}
						onChange={(text) => props.onChange?.(props.selected ?? false, text)}
					/>
				</Box>
			)}
		</FlexGap>
	);
}
